<template>
  <div class="supervisorRightPages">
      <div>
          <supervisor-right-pie/>
      </div>

  </div>
</template>

<script>
import {mapState,mapMutations,mapActions} from 'vuex'
import supervisorRightPie from '../../components/supervisor/supervisorRightPie.vue'
import echarts from 'echarts';
export default {
    computed:{
    ...Vuex.mapState('supervisor',['ReportList']), 
       
       
     },
     components:{
       supervisorRightPie,
     },
     
     mounted(){
     },
     
     methods:{
         
         
         
        
      
       
     }
}
</script>

<style>

</style>